import axios from "axios";
import { SENT_INVITATIONS_URL } from "../../utils";

export const fetchSentInvitations = () => {
  return axios.get(SENT_INVITATIONS_URL);
};
